import { MdOutlineError } from 'react-icons/md';
import { ListItem, ListItemButton, ListItemIcon, Tooltip } from '@mui/material';
import type { FC } from 'react';

export const ChatConnectionError:FC<{error:string | undefined}> = ({ error="" }) => {
  return (
    <ListItem disablePadding className="flex items-center px-4 text-tc-4 font-interbold hover:text-tc-2 cursor-pointer" sx={{ width: 'unset' }}>
      <Tooltip title={error} placement="right">
        <ListItemButton sx={{ padding: 0, '&:focus': { background: 'unset' } }}>
          <ListItemIcon>
            <MdOutlineError className="nav-list-icon" />
            Connection Error
          </ListItemIcon>
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};
